import { useQuery } from '@tanstack/react-query'
import { zendeskQueries } from '@/features/zendesk-app'
import React from 'react'
import { Option } from '@/components/ui/Autocomplete/Autocomplete.types'
import { useTemplateStepsContext } from '@/features/templates'
import { useFormikContext } from 'formik'

const usePreviousStepCustomObjectKey = () => {
  const { values } = useFormikContext<any>()
  const { currentStep, steps } = useTemplateStepsContext()

  const getFieldName = () => {
    const previousStep = steps[currentStep - 1]

    if (previousStep.type !== 'zendesk_custom_object_key') {
      throw new Error('Previous step should be zendesk_custom_object_key')
    }

    return previousStep.data.key
  }

  const fieldName = getFieldName()

  return values[fieldName]
}
export const useCustomObjectFieldOptions = (): Option[] => {
  const key = usePreviousStepCustomObjectKey()

  const query = useQuery(zendeskQueries.customObjectsFields.list(key))

  return React.useMemo(
    () =>
      query.data?.custom_object_fields.map((customObjectField) => ({
        label: customObjectField.title,
        value: customObjectField.key,
      })) ?? [],
    [query.data]
  )
}
